import { render, staticRenderFns } from "./LmsCertificates.vue?vue&type=template&id=faad3c98&scoped=true"
import script from "./LmsCertificates.vue?vue&type=script&lang=js"
export * from "./LmsCertificates.vue?vue&type=script&lang=js"
import style0 from "./LmsCertificates.vue?vue&type=style&index=0&id=faad3c98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faad3c98",
  null
  
)

export default component.exports